'use client'

import Link from 'next/link'
import {useTranslations} from 'next-intl'
import {X} from 'lucide-react'
import {compareHref, COMPARE_MAX, useCompareList} from './useCompareList'

/**
 * The picks so far, pinned to the bottom of the search page, with the way
 * to the comparison. Absent until something is picked; one pick says one
 * more is needed rather than opening a table of one.
 */
export function CompareBar({locale}: {locale: string}) {
  const t = useTranslations('compare')
  const {items, toggle, clear} = useCompareList()
  if (items.length === 0) return null

  return (
    <aside className="u-compare-bar" aria-label={t('barLabel')} data-testid="compare-bar">
      <ul className="u-compare-bar__picks">
        {items.map((item) => (
          <li key={item.slug}>
            <button
              type="button"
              className="u-compare-bar__pick"
              aria-label={t('toggleRemove', {name: item.name})}
              onClick={() => toggle(item)}
            >
              <span className="u-compare-bar__name">{item.name}</span>
              <X aria-hidden="true" size={14} />
            </button>
          </li>
        ))}
      </ul>
      <div className="u-compare-bar__actions">
        <button type="button" className="u-btn u-btn--ghost u-btn--sm" onClick={clear}>
          {t('clear')}
        </button>
        {items.length >= 2 ? (
          <Link href={compareHref(locale, items)} className="u-btn u-btn--primary u-btn--md">
            {t('barGo', {count: items.length})}
          </Link>
        ) : (
          <span className="u-compare-bar__hint">{t('barNeedOne', {max: COMPARE_MAX})}</span>
        )}
      </div>
    </aside>
  )
}
